import { Action, createMemoryHistory, createBrowserHistory } from 'history';
import type { Update } from 'history';

import { gtmHelpers } from '@digital-dealer/utils';

import { buildPath } from './utils';
import { INTERNAL_PATH_QUERY_PARAMETER } from './configs';

const sharedHistory = window.xprops.isWidgetMode ? createMemoryHistory() : createBrowserHistory();

window.xprops.subscribeToParentHistoryChange(
  (parentSearch: string, shouldPreventAutoScroll: boolean = false): void => {
    const parentSearchParams = new URLSearchParams(parentSearch);
    const newPath = parentSearchParams.get(INTERNAL_PATH_QUERY_PARAMETER);

    const { location: { pathname, search } } = sharedHistory;
    const currentPath = buildPath(pathname, search);

    if (currentPath === newPath) {
      return;
    }

    if (!newPath) {
      window.xprops.pushToParentHistory(INTERNAL_PATH_QUERY_PARAMETER, currentPath);

      return;
    }

    sharedHistory.replace(newPath);

    if (!shouldPreventAutoScroll) {
      void window.xprops.scrollToWidget();
    }
  },
);

sharedHistory.listen(({ action, location }: Update): void => {
  const { pathname, search } = location;
  gtmHelpers.emitPageView(pathname);

  window.xprops.pushToParentHistory(INTERNAL_PATH_QUERY_PARAMETER, buildPath(pathname, search));

  if (action === Action.Replace) {
    return;
  }

  void window.xprops.scrollToWidget();
});

export default sharedHistory;
